module.exports = __webpack_public_path__ + "img/onboarded.6edb9360.svg";